import React, {FC} from 'react';
import {routes} from 'app/routes';
import {ISuggestionComponent} from '../suggestions.types';
import styles from '../styles/suggestionItem.module.scss';
import {ITraining} from 'app/api/suggestionsAPI/suggestionsAPICaller.types';
import classNames from 'classnames';

export const Training: FC<ISuggestionComponent<ITraining>> = ({
    item,
    onPush,
    selected,
    itemRef,
    categoryI,
    itemI,
}) => {
    const {id, name, provider, icon, searchString, historyDate} = item;

    return (
        <div
            className={classNames(styles.suggestionItem, selected ? styles.selected : undefined)}
            onClick={() => onPush(routes.search_training, id, searchString, historyDate)}
            ref={el => {
                itemRef.current[categoryI] = itemRef.current[categoryI] || [];
                itemRef.current[categoryI][itemI] = el;
            }}
        >
            {icon && (
                <div className={styles.icon}>
                    <img src={icon} alt="" />
                </div>
            )}
            <div className={styles.info}>
                <div className={styles.title}>{name}</div>
                <div className={styles.subTitle}>{provider}</div>
            </div>
        </div>
    );
};
